export default __webpack_public_path__ + "static/media/glossary-card-image.699bfcea.jpg";